import { useLocation } from "@reach/router";
import React, { useState } from "react";
import { useKiosk } from "../../../context/kiosk";
import { KioskOverlay } from "../../app/kioskOverlay";
import { Button } from "../../form/button";
import { Bar, Heading } from "./kioskBar.styles";

export const KioskBar = () => {
  const { resetKiosk, dismissWarning, secondsRemaining, warningActive } = useKiosk();
  const { pathname } = useLocation();

  if (pathname === "/kiosk/") return null;

  const [confirm, setConfirm] = useState(false);

  return (
    <>
      <Bar>
        <Heading>Booking</Heading>
        <Button onClick={() => setConfirm(true)} label="Start over" color="blue" />
      </Bar>
      {warningActive ? (
        <KioskOverlay secondsRemaining={secondsRemaining} heading="Still there?" description="Tap Keep going to carry on with your booking, or Start over to start a new one." buttons={[{ label: "Start over", onClick: resetKiosk },{ label: "Keep going", onClick: () => { setConfirm(false); dismissWarning(); } }]} />
      ) : confirm ? (
        <KioskOverlay heading="Are you sure?" description="Your booking won't be completed and you'll go back to the start." buttons={[{ label: "Start over", onClick: resetKiosk },{ label: "Keep going", onClick: () => setConfirm(false) }]} />
      ) : null}
    </>
  );
};
